import React from 'react';

import lock from '@/public/assets/lock.png';
import lock2x from '@/public/assets/lock@2x.png';
import lock3x from '@/public/assets/lock@3x.png';
import ImgIcon from '../BaseIcon';

const Lock = () => (
    <ImgIcon
        srcset={`${lock},
                ${lock2x} 2x,
                ${lock3x} 3x,`}
        src={lock3x}
        alt="lock"
    />
);

export default Lock;
